import { Routes, Route, useLocation } from "react-router-dom";
import { NavBar } from "./components/NavBar";
import { HomePage } from "./pages/HomePage";
import { WorkPage } from "./pages/WorkPage";
import { AboutPage } from "./pages/AboutPage";
import { WorkOverview } from "./components/WorkOverview";
import { ScrollToTopOnNav } from "./components/ScrollToTopOnNav";
import { useEffect } from "react";
import "./App.css";

function App() {
  const location = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  return (
    <>
      <ScrollToTopOnNav />
      <NavBar />
      <Routes location={location}>
        <Route path="/" element={<HomePage />} />
        <Route path="/projects/:id" element={<WorkPage key={location.key} />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/overview" element={<WorkOverview />} />
      </Routes>
    </>
  );
}

export default App;
